<template>
  <div>
  <header class="mdc-top-app-bar top-app-bar top-header">
    <div class="mdc-top-app-bar__row">
      <section v-if="categoryList" class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start position-relative">
        <button aria-label="Open navigation menu"
                class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button hide-desktop navToggle">menu</button>
        <!-- Title button -->
        <button id="top-home-btn" class="mdc-top-app-bar__title t-subtitle4 mgl-12 pdl-0 cursor-pointer font-b t-color-white" tabindex="0" @click="$router.push('/home')">{{ title }}</button>

        <!-- Category button -->
        <div v-if="isSkillPath">
          <button v-show="!hideCategory && categoryList.length > 0"
              class="mgl-40 position-relative mdc-menu-anchor menu-container cursor-pointer header-toggle d-flex align-items-center pdl-0 pdr-0 category-btn"
              tabindex="0" @click="setMicroCategoryToggle">
            <div 
              class="t-body2 t-color-white  h-48 d-flex align-items-center font-r category-btn-text"
              :class="isMicroCategory ? 't-color-secondaryBtnText' : ''"
            >
              {{$t('3195')}}
            </div>
            <i 
              class="material-icons mdc-icon-button t-color-white t-headline6 js--dropdown-toggle header-category-toggle-icon pdr-0 w-30 category-btn-icon"
              :class="isMicroCategory ? 't-color-secondaryBtnText' : ''"
            >
              {{ isMicroCategory ? 'arrow_drop_up' : 'arrow_drop_down'}}
            </i>
          </button>
        </div>
        <div v-else>
          <button v-show="!hideCategory && categoryList.length > 0"
              class="mgl-40 position-relative mdc-menu-anchor menu-container cursor-pointer header-toggle d-flex align-items-center pdl-0 pdr-0 category-btn"
              tabindex="0" @click="setHomeCategoryToggle">
            <div 
              class="t-body2 t-color-white  h-48 d-flex align-items-center font-r category-btn-text"
              :class="isHomeCategory ? 't-color-secondaryBtnText' : ''"
            >
              {{$t('3195')}}
            </div>
            <i 
              class="material-icons mdc-icon-button t-color-white t-headline6 js--dropdown-toggle header-category-toggle-icon pdr-0 w-30 category-btn-icon"
              :class="isHomeCategory ? 't-color-secondaryBtnText' : ''"
            >
              {{ isHomeCategory ? 'arrow_drop_up' : 'arrow_drop_down'}}
            </i>
          </button>
        </div>
        

        <!-- IdpService Button -->
        <button v-show="!hideCategory && isIdpService" id="top-idp-btn"
                class="mgl-40 position-relative mdc-menu-anchor menu-container cursor-pointer header-toggle d-flex align-items-center pdl-0 pdr-0 category-btn"
                tabindex="0" @click="setRedirectServiceToggle">
          <div 
            class="t-body2 t-color-white  h-48 d-flex align-items-center font-r category-btn-text"
            :class="isServiceCategory ? 't-color-secondaryBtnText' : ''"
          >
            {{$t('30223')}}
          </div>
          <i 
            class="material-icons mdc-icon-button t-color-white t-headline6 js--dropdown-toggle header-category-toggle-icon pdr-0 w-30 category-btn-icon"
            :class="isServiceCategory ? 't-color-secondaryBtnText' : ''"
          >
            {{ isServiceCategory ? 'arrow_drop_up' : 'arrow_drop_down'}}
          </i>
        </button>

        <MicroSubjectCategoryList :isMicroCategory="isMicroCategory" :categoryList="categoryList" :categoryTotalPage="categoryTotalPage" :microCategoryList="microCategoryList" :microCategoryTotalPage="microCategoryTotalPage" :categoryBtnLocation="categoryBtnLocation" />
        <SubjectCategoryList :isHomeCategory="isHomeCategory" :isIdpService="isIdpService" :categoryList="categoryList" :categoryTotalPage="categoryTotalPage" :categoryBtnLocation="categoryBtnLocation"></SubjectCategoryList>
        <ServiceCategoryList :isServiceCategory="isServiceCategory" :categoryList="categoryList" :categoryTotalPage="categoryTotalPage" :idpBtnLocation="idpBtnLocation"></ServiceCategoryList>
        <div class="category-overlay" @click="handleClick" @keypress="handleClick" v-if="isMicroCategory || isHomeCategory || isServiceCategory" />
      </section>

      <!-- Toolbar -->
      <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar" v-if="memberDetail">
        <UserImgProfile :allData="memberDetail" :data="memberDetail" :className="'w-32 h-32 mgr-16'" :size="'main-size'" />
        <div class="t-body2 t-color-white font-r mgr-24">{{ memberDetail.name ? $t('3437',{first: memberDetail.name.first, last: memberDetail.name.last}):''}}</div>
        <button class="t-body2 t-color-white pdr-0 mgr-18 cursor-pointer font-r" tabindex="0" @click="logout" @keypress="logout">{{ $t("2064") }}</button>
      </section>
    </div>
  </header>
  </div>
</template>

<script>
/**
 * 메뉴별 메인 컴포넌트용 앱바 컴포넌트(Appbar Components for Main Components by Menu)
 *
 * @author minkyoung.park@emcast.com
 */
import memberApi from "@/api/memberApi.js";
import {mapActions, mapState} from 'vuex'
import loginApi from "@/api/loginApi.js";
import localStorageUtil from "@/utils/localStorageUtil";
import SubjectCategoryList from "@/components/common/CategoryList.vue";
import ServiceCategoryList from "@/components/common/ServiceCategoryList.vue";
import MicroSubjectCategoryList from "@/components/common/MicroCategoryList.vue";
import mainApi from "@/api/mainApi";
import UserImgProfile from "./common/checkUser/UserImgProfile.vue";

export default {
  components: { ServiceCategoryList, SubjectCategoryList, MicroSubjectCategoryList, UserImgProfile },

  props: [
    "leftBtnMode",
    "rightBtnMode",
    "title",
    "leftBtnMethod",
    "rightBtnMethod",
    "staticMode",
    "hideCategory"
  ],

  watch: {
    $route(to, from) {
      // this.getSubjectList();
      console.log(111)
    },
  },

  data() {
    return {
      memberImageUrl: "",
      memberName: "",
      memberDutyName:"",
      memberDutyRoleName: "",
      memberResponsibilityName: "",
      isDrawerOpen: false,
      isMicroCategory: false,
      isHomeCategory: false,
      isServiceCategory: false,
      categoryList: null,
      categoryTotalPage: 1,
      microCategoryList: null,
      microCategoryTotalPage: 1,
      brandName: localStorage.getItem('brandName'),
      routeName: [],
      direction: "",
      isIdpService: localStorageUtil.isIdpServiceValidate(),
      isSkillPath: localStorageUtil.isSkillPath(),
      categoryBtnLocation: 0,
      idpBtnLocation: 0,
    };
  },

  async mounted() {
    this.memberName = localStorage.getItem("memberName") || '';
    this.routeName = this.$route.path.split("/").slice(1);
    this.direction = document.querySelector('html').getAttribute('dir');

    await Promise.all([this.getSubjectList(), this.getMicroSubjectList(), this.getMemberDetails()]);

    // 초기 위치 설정
    this.getTopBarLocation();
    window.addEventListener('resize', this.getTopBarLocation);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.getTopBarLocation);
  },

  computed: {
    ...mapState({
      memberDetail: (state) => state.member.memberDetail,
    })
  },

  methods: {
    ...mapActions('member', ['SET_MEMBER_DETAIL']),
    ...mapActions('nav', ['SET_IS_OPEN_CATEGORY']),

    handleClick() {
      this.isServiceCategory = false;
      this.isHomeCategory = false;
      this.isMicroCategory = false;
      this.SET_IS_OPEN_CATEGORY(false)
    },

    setMicroCategoryToggle() {
      this.isHomeCategory = false;
      this.isServiceCategory = false;
      this.isMicroCategory = !this.isMicroCategory;
      this.SET_IS_OPEN_CATEGORY(true)
    },

    setHomeCategoryToggle() {
      this.isMicroCategory = false;
      this.isServiceCategory = false;
      this.isHomeCategory = !this.isHomeCategory;
      this.SET_IS_OPEN_CATEGORY(true)
    },

    setRedirectServiceToggle() {
      this.isMicroCategory = false;
      this.isHomeCategory = false;
      this.isServiceCategory = !this.isServiceCategory;
      this.SET_IS_OPEN_CATEGORY(true)
    },

    getMemberDetails() {
      memberApi.getMemberInfo().then((response) => {
        let responseData = response.data.data;
        this.memberImageUrl = responseData.profile;
        this.memberName = responseData.name.fullName;
        this.memberDutyName = responseData.dutyName;
        this.memberDutyRoleName = responseData.dutyRole.text;
        this.memberResponsibilityName = responseData.responsibilityName;
        localStorage.setItem("memberName", this.memberName);
        this.SET_MEMBER_DETAIL(responseData);
      });
    },

    async getSubjectList() {
      try {
        const result = await mainApi.fetchSubject({
          page: 1,
          size: 20,
        });
        this.categoryList = result.data.data.content.filter(val => val.desktopMain);
        this.categoryTotalPage = result.data.data.totalPages;
      } catch (error) {
        console.log("GET SUBJECT LIST ERROR : ", error);
      }
    },

    getMicroSubjectList() {
      mainApi.fetchMicroSubject({
        page: 1,
        size: 20,
      }).then((response) => {
        this.microCategoryList = response.data.data.content;
        this.microCategoryTotalPage = response.data.data.totalPages;
        return this.microCategoryList;
      }).catch((err) => {
        console.log("Get Micro SubjectList Error : ", err);
      })
      
    },

    logout() {
      if(this.isIdpService) {
        this.$moveIdpLogout();
      } else {
        loginApi
            .logout()
            .then((response) => {
              localStorageUtil.init();
              this.$router.push("/");
            }).catch((err) => {
          localStorageUtil.init();
          this.$router.push("/");
        });
      }
    },

    // Open drawer
    openDrawer() {
      this.isDrawerOpen = true;
    },

    // Close drawer
    closeDrawer() {
      this.isDrawerOpen = false;
    },

    getTopBarLocation() {
      if (document.querySelector("#top-home-btn")) {
        let homeBtn = document.querySelector("#top-home-btn");
        this.categoryBtnLocation = homeBtn.getBoundingClientRect().left + homeBtn.clientWidth + 40;
      }

      if (document.querySelector("#top-idp-btn")) {
        let idpBtn = document.querySelector("#top-idp-btn");
        this.idpBtnLocation = idpBtn.getBoundingClientRect().left;
      }
    },
  },
};
</script>

<style scoped>
.category-btn-text, .category-btn-icon {
  transition: all 0.1s ease-in-out;
}
.category-btn:hover .category-btn-text, .category-btn:hover .category-btn-icon {
  color: var(--Secondarybtntext) !important;
}
</style>
